<template>
	<div class="qualityenterprise" v-title :data-title="title">
		<leftnav class="fl" mkcode="B" itemcode="B-CYSJK"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 0;">
					<div class="right_boxtitle">
						<span class="fl right_title">产业数据库</span>
					</div>
					<!-- 产业概念细分筛选 -->
					<notionScreen :type="2" :notionNumberList="notionNumList" :refreshNum="notionNumRefresh"
						:token="userdata.token" @chooseNotion="chooseNotion" :isShowNotionScreen="true"
						:isClearNotion="isClearNotion" :showLevelNum="3" :isShowOneLevelTotal='false'>
					</notionScreen>
					<dl class="opport-screen bdbe">
							<dt class="fl">统计数据</dt>
							<dd class="fl">
								<span @click="statisticalValue = 0"
									:class="statisticalValue == 0?'a-screen current':'a-screen'">全部</span>
								<span :key="index" v-for="(item,index) in statisticalDataOptions"
									@click="statisticalValue = item.value"
									:class="statisticalValue == item.value?'a-screen current':'a-screen'">{{item.label}}</span>
							</dd>
					</dl>
				</div>
				<div class="whitebox pb-4 pt-3">
					<div class="scrollable-table-wrapper">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table growth_table">
							<tr>
								<th></th>
								<th><span class="inline-block width50PC">2024年</span> <span
										class="inline-block width50PC">增长率</span></th>
								<th><span class="inline-block width50PC">2023年</span> <span
										class="inline-block width50PC">增长率</span></th>
								<th><span class="inline-block width50PC">2022年</span> <span
										class="inline-block width50PC">增长率</span></th>
								<th><span class="inline-block width50PC">2021年</span> <span
										class="inline-block width50PC">增长率</span></th>
								<th><span class="inline-block width50PC">2020年</span> <span
										class="inline-block width50PC">增长率</span></th>
								<th><span class="inline-block width50PC">2019年</span> <span
										class="inline-block width50PC">增长率</span></th>
								<th><span class="inline-block width50PC">2018年</span> <span
										class="inline-block width50PC">增长率</span></th>
							</tr>
								<tr  v-show="statisticalValue == 0 || statisticalValue == 1">
									<td class="font-weight text-left py-col-15 border-top fixd-title">上市公司</td>
									<td colspan="7"></td>
								</tr>
								<tr v-for="(list, i) in enterpristlist" :key="i + 'ss'" v-if="list.id < 5" v-show="statisticalValue == 0 || statisticalValue == 1">
									<td class="text-dent text-left">上市公司总数<span class="font-size14"
											v-if="list.title != '上市公司数'">({{ list.unit ? list.unit : '' }})</span></td>
									<td v-for="(item, dataI) in list.data" :key="'s' + dataI"><span
											class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
											class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
									<td v-for="(item, dataI) in 7" :key="dataI + '_s'" v-if="list.data.length == 0"><span
											class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
									</td>
								</tr>
								<tr v-show="statisticalValue == 0 || statisticalValue == 2">
								<td class="font-weight text-left py-col-15 border-top">新增投资项目</td>
								<td colspan="7"></td>
							</tr>
							<tr v-for="(list, i) in enterpristlist" :key="i + 'tz'" v-show="statisticalValue == 0 || statisticalValue == 2"
								v-if="list.title == '投资项目数量' || list.title == '投资项目金额'">
								<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
										v-if="list.title == '投资项目金额'">({{ list.unit ? list.unit : '' }})</span></td>
								<td v-for="(item, dataI) in list.data" :key="dataI + 'itz'"><span
										class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
										class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
								<td v-for="(item, dataI) in 7" :key="dataI + '_t'" v-if="list.data.length == 0"><span
										class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
								</td>
							</tr>
							<tr v-show="statisticalValue == 0 || statisticalValue == 3">
								<td class="font-weight text-left py-col-15 border-top">新增融资项目</td>
								<td colspan="7"></td>
							</tr>
							<tr v-for="(list, i) in enterpristlist" :key="i + 'rz'" v-show="statisticalValue == 0 || statisticalValue == 3"
								v-if="list.title == '融资项目数量' || list.title == '融资项目金额'">
								<td class="text-dent text-left">{{ list.title }} <span class="font-size14"
										v-if="list.title == '融资项目金额'">({{ list.unit ? list.unit : '' }})</span></td>
								<td v-for="(item, dataI) in list.data" :key="'rz' + dataI"><span
										class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
										class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
								<td v-for="(item, dataI) in 7" :key="dataI + '_r'" v-if="list.data.length == 0"><span
										class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
								</td>
							</tr>
							<tr v-show="statisticalValue == 0 || statisticalValue == 4">
								<td class="font-weight text-left py-col-15 border-top" >新增拿地项目</td>
								<td colspan="7"></td>
							</tr>
							<tr v-for="(list, i) in enterpristlist" :key="i + 'nd'" v-show="statisticalValue == 0 || statisticalValue == 4"
								v-if="list.title == '拿地项目数量' || list.title == '拿地项目金额' || list.title == '拿地项目面积'">
								<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
										v-if="list.title == '拿地项目金额' || list.title == '拿地项目面积'">({{ list.unit ? list.unit : '' }})</span>
								</td>
								<td v-for="(item, dataI) in list.data" :key="'nd' + dataI"><span
										class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
										class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
								<td v-for="(item, dataI) in 7" :key="dataI + '_n'" v-if="list.data.length == 0"><span
										class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
								</td>
							</tr>
							<tr v-show="statisticalValue == 0 || statisticalValue == 5">
								<td class="font-weight text-left py-col-15 border-top" v-show="productList.length > 0">当年产品产量</td>
								<td colspan="7" v-show="productList.length > 0"></td>
							</tr>
							<tr v-for="(list, i) in productList" :key="i + 'pro'" v-show="statisticalValue == 0 || statisticalValue == 5">
								<td class="text-dent text-left">{{ list.title }} <span
										class="font-size14">({{ list.unit ? list.unit : '' }})</span></td>
								<td v-for="(item, dataI) in list.data" :key="'pro' + dataI"><span
										class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
										class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
								<td v-for="(item, dataI) in 7" :key="dataI + '_pro'" v-if="list.data.length == 0"><span
										class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'industryLibrary',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			curWebsite: this.$api.getWebsiteType(),
			title: "行业库",
			userdata: {},
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10,  //最大页数
			enterpristlist: [],
			kwtextsearchtext: '',
			kwtextsearch: '',
			notionlist: [],
			notionlist2: [],
			chooseNotion0: 'A',
			chooseNotion1: "",
			chooseNotion2: '',
			testList: [],
			industryType: 1,
			notionlistClass: [{ label: "先进制造业", value: "A", industryType: 1, children: [] }, { label: "制造业（国民经济行业分类）", value: "C", industryType: 2, children: [] },],
			productList: [],
			notionNumList: [],
			notionNumRefresh: 1,
			isClearNotion: false,
			notionCode: 'A',
			notionstep: '',
			statisticalDataOptions:[{label:'上市公司',value:1},{label:'投资项目',value:2},{label:"融资项目",value:3},{label:"拿地项目",value:4},{label:"产品产量",value:5}],
			statisticalValue: 0,
		}
	},
	beforeCreate() {
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuserinformain();
		this.ajaxsearchcompany();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		document.title = this.title + "-产业研究"
		var _this = this;
	},
	methods: {
		//概念单选 层级显示
		chooseNotion(chooseNotionlist, notionCode, step) {
			// console.log(chooseNotionlist,notionCode);
			this.notionCode = notionCode;
			if (step) {
				this.notionstep = step;
			}
			var sortStr = (step && step < 3) ? 'sort' : '';
			this.ajaxsearchcompany(1, sortStr);
		},
		//有小数点四舍五入保留两位小数，没小数点不变
		toFixedFn(number) {
			let fixedNum;
			if (number && String(number).indexOf('.') !== -1) {
				fixedNum = number.toFixed(2);
			} else {
				fixedNum = number;
			}
			return fixedNum;
		},

		pageHandler(page) {
			this.page = page;
			this.ajaxsearchcompany(page);
		},
		ajaxsearchcompany(pages) {
			this.bus.$emit('loading', true);
			var _this = this;
			let industryCode = this.splicing('industryCode', this.notionCode);
			let ajaxUrl = this.$api.cyl.industryData.list() + '?industryType=1' + industryCode;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					console.log('列表数据', res.data.list)
					_this.enterpristlist = res.data.list;
					_this.productList = res.data.data.product;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
	}
}
</script>

<style scoped>
.font-size14 {
	font-size: 14px;
}

.text-left {
	text-align: left;
}

.pr-2 {
	padding-left: 20px !important;
}

.pt-3 {
	padding-top: 30px;
}

.py-col-15 {
	padding: 15px 0 15px 20px !important;
}

.text-dent {
	/* text-indent:2em; */
	padding-left: 35px !important;
}

.min-widht130 {
	min-width: 130px !important;
}

.width50PC {
	width: 100px;
}

.inline-block {
	display: inline-block;
	padding: 15px 10px;
	word-wrap: break-word;
	/* border-right: 1px solid #ececec; */
}
.table-min-width{
	min-width: 2000px;
}
.growth_table td {
	padding: 0;
	align-items: center;
	vertical-align: middle;
	min-width: 200px;

}
.growth_table {
	min-width: 2000px;
	width: 100%;
	table-layout: fixed;/* 固定表格布局，确保列宽度一致 */
}

.scrollable-table-wrapper {
	/* height: 630px; */
	height: calc(100vh - 440px);
	width: 95%;
	margin: 0 auto;
	overflow: auto;/* 使得内容可以横向滚动 */
	margin-left: 40px;
}

/* 定义滚动条整体样式 */
.scrollable-table-wrapper::-webkit-scrollbar {
  width: 10px; /* 设置滚动条的宽度 */
  height: 10px;/* 设置滚动条的高度 */
  background-color: #e9e8e8; /* 背景色 */
  border-radius: 10px; /* 圆角 */

}
/* 定义滚动条轨道样式 */
.scrollable-table-wrapper::-webkit-scrollbar-track {
  opacity: 0.5;
  box-shadow: inset 0 0 5px rgb(255, 255, 255); /* 轨道阴影 */
}

/* 鼠标滑过时滑块的背景色 */
.scrollable-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgb(128, 126, 126); 
}
/* 定义滚动条滑块样式 */
.scrollable-table-wrapper::-webkit-scrollbar-thumb {
  background: rgb(197, 197, 197); /* 设置滚动条滑块颜色 */
  border-radius: 10px; /* 圆角 */

}

.growth_table th{
	font-weight: bold;
	min-width: 200px;
	position: sticky;
	top: 0;
	/* z-index: 1; */
}
.growth_table td:first-child{
	position: sticky;
	left: 0;
	background: #fff;
}
.growth_table th:first-child {
	position: sticky;
	left: 0;
	z-index: 1;
}
</style>